import type { ActivityViewProps } from '../../core/types/activity.types';
import { MathEquationView } from './MathEquationView';

export function MathEquationActivityView(props: ActivityViewProps<'math_equation'>) {
  return <MathEquationView payload={props.payload} />;
}
